<template>
    <div class="lang-switch">
        <strong>
            <span @click='handleSetLanguage("FR")' class="pointer">FR </span>|
            <span @click='handleSetLanguage("NL")' class="pointer">NL</span>
        </strong>
    </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
const { mapMutations } = createNamespacedHelpers('lang')

export default {
  name: 'LangSwitch',
  data: function () {
    return {
    }
  },
  methods: {
    ...mapMutations({
      setLang: 'UPDATE_LANG'
    }),
    handleSetLanguage (lang) {
      this.$i18n.locale = lang
      this.setLang(lang)
    }
  }
}
</script>
